  $(document).ready(function(){
  $('.tab_collection_item:first-child').addClass('open');
  $('.grid-tab-content:first-child').addClass("active");
  $(document).on('click','.tab_collection_item',function(){
    $(this).addClass("open").siblings().removeClass("open"); 
    var collUrl = $(this).find('.tab_button').data('url');
    $('.tab_collect_links').attr('href', collUrl)
    var tab_id = $(this).find('.tab_button').attr('data-id');
    $('.grid-tab-content').each(function() {
      var tab_item = $(this).attr('id');
      if (tab_id == tab_item){
      //$('.grid--uniform:first-child').hide();
      $(this).addClass("active").siblings().removeClass("active");
      }
    });     
  }); 


 $(".imagewithtextSlider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M0.5 35C0.5 37.4853 2.51472 39.5 5 39.5H35C37.4853 39.5 39.5 37.4853 39.5 35V5C39.5 2.51472 37.4853 0.5 35 0.5H5C2.51472 0.5 0.5 2.51472 0.5 5V35Z" stroke="#0faac7"/><path d="M24 12L16 20L24 28" stroke="#fff" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M39.5 5C39.5 2.51472 37.4853 0.5 35 0.5H5C2.51472 0.5 0.5 2.51472 0.5 5V35C0.5 37.4853 2.51472 39.5 5 39.5H35C37.4853 39.5 39.5 37.4853 39.5 35V5Z" stroke="#0faac7"/><path d="M16 28L24 20L16 12" stroke="#fff" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false,
           autoplay:true, 
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1, 
          slidesToScroll: 1,
          autoplay:true,
        },
      },
    ],
  });
 $(document).on('click','.collapsibles-verticle__button button.btn-verticle__tab',function(){
  $('.collapsibles-verticle__button button.btn-verticle__tab').removeClass("is-open"); 
  $(this).addClass("is-open"); var tab_id = $(this).data('id');
  $('.collapsibles-verticle__content .verticle__tab_description-content').removeClass("is-open").hide(); 
  $('#'+tab_id).addClass("is-open").show();
 });
 $('.product-tab--button button.btn-product__tab:first-child').addClass("is-open"); 
 $(document).on('click','.product-tab--button button.btn-product__tab',function(){
  $('.product-tab--button button.btn-product__tab').removeClass("is-open"); 
  $(this).addClass("is-open"); 
  var tab_id = $(this).data('id');
  $('.product__tab_description-content').removeClass("is-open").hide(); 
  $('#'+tab_id).addClass("is-open").show();
 }); 

  if($(document).find('.itg_product__meta').length > 0){
     $("ul.itg_color_metafield li").hover(function(){
       $(document).find("ul.itg_color_metafield li").removeClass('active_variant')
       var ths_title = $(this).attr('data-color');
       $(this).closest('.itg_product__meta').find('.color_var').text(ths_title);
       $(this).addClass('active_variant');
     });
  }
    
 });